import { Space, Title, Descriptions, Text } from '@bancobarigui/barihaus';
import type { CardFormacaoValorProps } from './types';
import { useValorTotal } from './hooks';
import { formatarMoeda } from './utils';

export function CardFormacaoValor({
  valorUnitarioSaneado,
  areaInicialTerreno = 1489.5,
}: CardFormacaoValorProps) {
  const valorTotal = useValorTotal(areaInicialTerreno, valorUnitarioSaneado);

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Title level={4} style={{ margin: 0 }}>
        Formação do Valor
      </Title>

      <Descriptions
        bordered
        size="small"
        column={1}
        items={[
          {
            key: '1',
            label: 'Área do terreno',
            children: `${Number(areaInicialTerreno || 0).toFixed(2)} m²`,
          },
          {
            key: '2',
            label: 'Valor unitário (R$/m²)',
            children: formatarMoeda(valorUnitarioSaneado),
          },
          {
            key: '3',
            label: 'Valor total (R$)',
            children: (
              <Text style={{ fontWeight: 600, color: '#1890ff', fontSize: 16 }}>
                {formatarMoeda(valorTotal)}
              </Text>
            ),
          },
        ]}
      />
    </Space>
  );
}
